<template>
  <div id="home">
    <div>
      <el-row>
        <el-col :span="3">
          <div id="nav">
            <el-row class="tac">
              <el-col :span="24">
                <div class="title">
                  <span>油地人才直聘</span>
                </div>
                <div class="image-box">
                  <!-- <div class="image"></div> -->
                  <!--                  <el-avatar :size="68" :src="$store.state.userImg || userImg" class="user-img userImag"></el-avatar>-->
                  <!--                  <span>{{ userName }}</span>-->

                  <el-upload
                      class="avatar-uploader"
                      action="https://upload.xuruidea.com/uploadFile?type=1"
                      :show-file-list="false"
                      :on-success="handleAvatarSuccess"
                      :before-upload="beforeAvatarUpload">
                    <img v-if="$store.state.userImg" :src="$store.state.userImg" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                  <span>{{ userName }}</span>

                </div>

                <!-- 导航  $route.fullPath   /company-->

                <el-menu
                    router
                    class="menu el-menu-vertical-demo"
                    @open="handleOpen"
                    @close="handleClose"
                    background-color="#25272F"
                    text-color="#616779"
                    active-text-color="#ffffff"
                    :default-active="$route.fullPath"
                >
                  <template v-for="(item,index) in navData">
                    <el-submenu :index="item.url" v-if="item.children.length>0">
                      <template slot="title">

                        <span>{{ item.displayName }}</span>
                      </template>
                      <el-menu-item-group v-for="(childItem,index) in item.children" :key="index">
                        <el-menu-item :index="childItem.url">{{ childItem.displayName }}</el-menu-item>
                      </el-menu-item-group>
                    </el-submenu>
                    <el-menu-item :index="item.url" v-else :class="{chat:item.displayName=='聊天'}">
                      <span slot="title">{{ item.displayName }}</span>
                      <el-badge :value="$store.state.message.unreadNewsCount" :max="99" class="item"
                                v-if="item.displayName=='聊天'"></el-badge>
                    </el-menu-item>

                  </template>


                </el-menu>
              </el-col>
            </el-row>
          </div>

        </el-col>


        <el-col :span="21">
          <router-view/>
        </el-col>
      </el-row>
    </div>

  </div>
</template>
<script>
import Head from '@/components/header/head.vue'
// import {initWebSocket} from '@/utils/webSocket/wSocket.js'
import {createWebSocket} from '@/utils/webSocket/webSocket.js'
import login from "@/views/login/login";
// import {webSocket} from '@/utils/webSocket/wSocket.js'
export default {
  data() {
    return {
      userInfo: '',    // 用户信息
      userImg: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',     // 默认管理员头像
      // 聊天信息
      socket: '',   // 存放webSocket
      identityStatus: '1',   // 身份状态
      // img:'@/assets/four.jpg',
      userName: '',    // 用户姓名
      navData: []      // 左侧导航数据
    }
  },
  components: {
    Head
  },
  methods: {
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },

    // 文件上传成功时的钩子
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      if (res.code == 200) {
        // /userBaseInfo/save/headPortrait
        this.axiosPost("/userBaseInfo/save/headPortrait", {
          headPortrait: res.data.httpsUrl,
          userId: this.userInfo.id,
        }).then((res) => {
          if (res.code == 200) {
            this.axiosGet(`/userBaseInfo/findByUserId/${this.userInfo.id}`).then((res) => {
              if (res.code == 200) {
                this.$message.success('头像上传成功！')
                this.$store.commit("updateUserImg", res.data.headPortrait);
              }
            }, (e) => {
              // console.log(e)
            })
          }
        })
      }
    },

    // 上传文件之前的钩子
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },

    // 获得聊天列表消息
    // getMeaageList(){
    //     this.axiosGet(`/conversation/selectByUserId?userId=${this.userInfo.id}&identityStatus=${this.identityStatus}`).then((res)=>{
    //         console.log('消息list')
    //         console.log(res)
    //         if(res.code==200){
    //             this.$store.commit('updateMsg',res.data)
    //             //   publicVue.chartInfo = res.data
    //             // console.log('消息list')
    //             // console.log(res.data)
    //             //   this.$store.commit('updateMsgNum',res.dataunreadNewsCount)
    //         }
    //     })
    // },

  },

  created() {
    let that = this
    this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
    let userId = this.userInfo.id
    let userRole = this.userInfo.identityStatus
    // setInterval(function(){
    //
    // },500)
    //  that.getMeaageList()
//         let scoketMessage = {
//                         sendId:userId,  //发送人id
//                         receiveId:'0',  //接收人id，第一次登陆不需要
//                         content:'0',    //消息内容，第一次登陆不要
//                         type:'0',   //消息类型，第一次登陆不要 0第一次连接 1发送简历   2发送面试邀请 3发送代招的职位  4接受了面试邀请  5拒绝了面试邀请
//                         status:'1'  ,//状态，1就是第一次连接  2正常聊天   3心跳包
//                         identityStatus:userRole,    //当前登陆用户身份
//                         receiveIdentity:'1',        //接收人身份， 第一次不需要
//                         generationChat:'0', //当前登陆用户是否为代招客服   0正常聊天   1代招客服聊天
//                         generationCompanyId:'', //代招公司id
//                         resumeId:'',    //简历id，发简历时用到
//                         interviewId:'', //面试邀请id， 发送面试邀请时用到
//                         generationPostId:'',    //代招职位id，
//                         postId:'',  //职位id，
//                     }
//         // 获得webSocket对象
    // window.socket = createWebSocket()
    // let time;
    // socket.onopen = function(e){
    //     console.log('连接成功')
    //     console.log(e)
    //     socket.send(JSON.stringify(scoketMessage))
    //
    //     console.log('readyState')
    //     console.log(socket.readyState)
    //      //    心跳函数
    //      if(socket.readyState==1){
    //         if(time){clearInterval(time)}
    //         time = setInterval(function(){
    //             console.log('心跳函数')
    //             socket.send(JSON.stringify({status:3}))
    //         },10000)
    //      }
    // }

    // 获得消息
    // socket.onmessage = function(res){
    //     console.log('获得到了消息')
    //     console.log(JSON.parse(res.data))
    //     console.log(JSON.parse(res.data))
    //     // publicVue.message = res.data
    // }

    // window.sendText = function(txt){
    //     socket.onopen = function(){
    //         console.log('正在发送')
    //         socket.send(txt)
    //     }
    // },
    // window.onbeforeunload = function() {
    //     socket.close();
    // }

    this.$store.commit('updateUserImg', this.userInfo.logo)
    this.axiosGet(`/web/menu/findRole/${userId}`).then((res) => {
      // console.log('左侧导航')
      // console.log(res)
      if (res.code == 200) {
        // (res.data).shift()
        this.navData = res.data
        this.userName = this.userInfo.companyName
        // console.log('this.userInfo: ', this.userInfo);
      }
    }, (e) => {
    })

  }
}
</script>
<style lang="less" scoped>

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
  border-radius: 100px;
}

.item {
  position: absolute;
  right: 25%;
  top: -10px;
}

.chat {
  position: relative;
}

#home {
  background-color: #E6ECF8;
}

.user-img {
  display: block;
  margin: 0 auto;
}

// 公共样式部分
//   div,ul,li,a,p,html,h1,h2,h3,h4,h5,h6,span,body{
//     padding:0;
//     margin:0;
//     font-family:"font-family: Source Han Sans CN"
//   }
//   .row-top{
//     margin-top:20px;
//   }
//   .inp .el-form-item__content input{
//       font-size: 16px;
//       font-weight: 400;
//       color: #1A80FC;
//       line-height: 30px;
//   }


//   #app{
//     // width:1200px;
//     // margin:0 auto;
//     background-color:#E6ECF8;
//     // #home,#nav{
//     //   height:1080px

//     // }
//   }
//   .el-submenu .el-submenu__title{
//     font-size:16px;
//   }
//   li{
//     list-style: none;
//   }
//   .clearfix:after {
//     content: "";
//     display: block;
//     height: 0;
//     clear: both;
//     visibility: hidden;
//   }
//   .ts-inp.el-input.is-disabled .el-input__inner,
//   .ts-inp.el-input.is-disabled .el-input__icon{
//     cursor:pointer;
//   }


// //审核管理/企业认证/社会统一代码
//   .code{

//       .el-form-item__label{
//         white-space:pre-line;
//         text-align:left;
//         line-height:18px;

//       }
//       //如果是table的话就
//       .el-table .cell{
//           white-space:pre-line;
//       }
//   }


// // 导航部分
//   #nav{
//         height:1080px;
//         .el-menu-item{
//           font-size: 16px;
//           font-family: "Source Han Sans CN";
//           font-weight: 400;
//           color: #616779;
//         }
//     }
//     .tac{
//         background-color:#25272F;
//         font-size:8px;
//         height:100%;
//     }
//     .title{
//         font-size: 20px;
//         font-family: "Source Han Sans CN";
//         font-weight: 500;
//         color: #197FFB;
//         line-height: 60px;
//         text-align:center;
//     }
//     .image-box{
//        text-align:center;
//        margin-bottom:20px;
//         .image{
//             width: 68px;
//             height: 68px;
//             margin:0 auto;
//             border-radius: 50%;
//             background:url('../src/assets/four.jpg') 100% 100% no-repeat;
//         }
//         span{
//             font-size: 14px;
//             font-weight: 400;
//             color: #FFFFFF;
//             line-height: 30px;
//         }
//     }
//     .el-submenu .el-menu-item-group .el-menu-item{
//         min-width:100%;
//     }


//  head部分

// .head{
//     height:60px;
//     background-color:#ffffff;
//     // background-color:red;
//     .job{
//         font-size: 18px;
//         font-family: "Source Han Sans CN";
//         font-weight: 400;
//         color: #333333;
//         line-height: 60px;
//     }


//     .personal-zl{
//         height:60px;
//         // background-color:red;
//         line-height:60px;
//             .img{
//                 width: 40px;
//                 height: 40px;
//                 display:inline-block;
//                 vertical-align:middle;
//                 background: #4E72C8;
//                 border-radius: 50%;
//                 background:url("./assets/four.jpg") 100% 100% no-repeat;
//             }
//             .personal{
//                 margin-left:6px;
//                 font-size: 14px;
//                 font-family: "Source Han Sans CN";
//                 font-weight: 400;
//                 color: #333333;
//                 line-height: 60px;
//                 cursor:pointer;
//             }
//             .info{
//                 margin-left:10px;
//             }
//             .icon{
//                 font-size:27px;
//                 line-height:60px;
//                 cursor:pointer;
//                 color:#333333;
//             }
//             .log-out{
//                 position:relative;
//                 bottom:3px;
//             }

//     }

// }
</style>
